import React from "react";
import "./chubb_pa_series_b.css";

export default function ChubbPASeriesBCard({ onSelect }) {
  return (
    <div className="pkg-card chubb-pa-b">
      <div className="pkg-body">
        <h3>Chubb PA Series B (แผน 1–8 + Kid)</h3>
        <p>อุบัติเหตุส่วนบุคคล • ค่ารักษา • วันหยุดสาธารณะ • มอเตอร์ไซค์</p>
        <ul className="pkg-list">
          <li>ทุนชีวิต/ทุพพลภาพ สูงสุดตามแผน</li>
          <li>ค่ารักษาพยาบาลต่อครั้ง + ผลประโยชน์พิเศษ</li>
          <li>แพ็กเดี่ยว / คู่สมรส / ครอบครัว</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
